import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {copy} from 'shared/utils';
import {flashTooltip} from 'src/redux/aptitude/actions';
import {AptitudeStore} from 'src/types/store';

import Tooltip from 'src/components/tooltip';
import Icon from 'shared/components/icon';

import styles from './usage-table-row.module.scss';

interface Props {
  color: {
    name: string;
    hex: string;
    variable: string;
    usage: string;
    contrastRatio: string;
  };
}

const UsageTableRow = ({color: {name, hex, variable, usage, contrastRatio}}: Props) => {
  const dispatch = useDispatch();
  const showHexTooltip = useSelector(
    (state: AptitudeStore) => !!state.tooltips[`usage-table-${hex}`]
  );
  const showVarTooltip = useSelector(
    (state: AptitudeStore) => !!state.tooltips[`usage-table-${variable}`]
  );

  const addHexToClipboard = () => {
    copy(hex.toLowerCase().slice(1));
    dispatch(flashTooltip(`usage-table-${hex}`));
  };

  const addVarToClipboard = () => {
    copy(variable);
    dispatch(flashTooltip(`usage-table-${variable}`));
  };

  return (
    <tr className={styles.container}>
      <td className={styles.swatchColumn}>
        <label className={styles.swatchContainer} htmlFor="color-usage-swatch">
          {name}
          <div
            id="color-usage-swatch"
            className={styles.swatch}
            style={{backgroundColor: hex}}
          ></div>
        </label>
      </td>
      <td>
        <Tooltip placement="top" open={showHexTooltip} title="Copied!">
          <button className={styles.hexButton} onClick={addHexToClipboard}>
            {hex}
            <Icon iconType="copy-r" className={styles.copyIcon} />
          </button>
        </Tooltip>
      </td>
      <td>
        <Tooltip placement="top" open={showVarTooltip} title="Copied!">
          <button className={styles.variableButton} onClick={addVarToClipboard}>
            <code className={styles.code}>{variable}</code>
            <Icon iconType="copy-r" className={styles.copyIcon} />
          </button>
        </Tooltip>
      </td>
      <td>{usage}</td>
      <td className={styles.contrastRatio}>{contrastRatio}</td>
    </tr>
  );
};

export default UsageTableRow;
